<template>
  <div class="flex items-center gap-[16px] mb-[24px]">
    <div
      v-for="step in stepsData"
      :key="step.number"
      class="flex items-center gap-[8px] step-connector"
      :class="{'step-connector--done': step.done}"
    >
      <span
        class="w-6 h-6 flex items-center justify-center rounded-full transition-all duration-300"
        :class="{'bg-[#34A770] text-[#626262]' : step.done, 'bg-[#F95031] text-[#F95031]' : step.active, 'bg-[#828282] text-[#626262]' : !step.active}"
      >
        <span
          v-if="!step.done"
          class="text-white text-sm"
        >{{ step.number }}</span>
        <span
          v-else
          class="k-Checklist text-[26px] text-white"
        />
      </span>
      <span>{{ step.name }}</span></div>
  </div>
</template>

<script>
export default {
  name: 'WarehouseSelectStepIndicator',
  data() {
    return {
      stepsData: [
        {
          number: 1,
          name: 'Pilih Gudang',
          done: false,
          active: true,
        },
        {
          number: 2,
          name: 'Penyesuaian Alamat',
          done: false,
          active: false,
        },
      ],
    }
  },
  created() {
    this.currentStep = 1
  },
  methods: {
    /**
     * Move to the next step
     */
    nextStep() {
      this.currentStep += 1
      this.stepsData = [
        {
          number: 1,
          name: 'Pilih Gudang',
          done: true,
          active: false,
        },
        {
          number: 2,
          name: 'Penyesuaian Alamat',
          done: false,
          active: true,
        },
      ]
    },
    /**
     * Move to the previous step
     */
    prevStep() {
      this.currentStep -= 1
      this.stepsData = this.stepsData.map(step => ({
        ...step,
        done: step.number < this.currentStep,
        active: step.number === this.currentStep,
      }))
    },
  },
}
</script>

<style scoped>
.step-connector {
  position: relative;
}

.step-connector:last-child {
  &::after {
    display: none;
  }
}

.step-connector::after {
  content: '';
  position: relative;
  display: block;
  height: 1px;
  border-top: 1px solid #E2E2E2;
  width: 26px;
  transition: width 0.3s ease;
}

.step-connector--done::after {
  width: 70px;
}
</style>
